// ** Reducers Imports
import navbar from './navbar'
import layout from './layout'
import auth from './authentication'
import user from '@src/views/users/store'
import dashboard from '@src/views/dashboard/store'
import types from '@src/views/type/store'
import merk from '@src/views/merk/store'
import engine from '@src/views/engine/store'
import category from '@src/views/category/store'
import documents from '@src/views/document/store'
import aircraft from '@src/views/aircrafts/store'
import productivity from '@src/views/productivity/store'

const rootReducer = {
  auth,
  navbar,
  layout,
  user,
  dashboard,
  types,
  merk,
  engine,
  category,
  aircraft,
  documents,
  productivity
}

export default rootReducer
